<template>

    <div>
        <ClientOnly>
            <!-- Email Not Found Modal -->
            <n-modal v-model:show="showEmailNotFoundModal" :mask-closable="false" class="email-not-found-modal">
                <n-card style="border-radius: 12px;" :bordered="false">
                    <div class="email-not-found-content">
                        <div class="modal-header">
                            <h3>Email Not Found</h3>
                            <div class="not-fund-modal-close-btn">
                                <n-icon size="20" class="close-icon" @click="showEmailNotFoundModal = false">
                                    <Close />
                                </n-icon>
                            </div>
                            <!-- <n-icon size="20" class="close-icon" @click="showEmailNotFoundModal = false">
                                <Close />
                            </n-icon> -->
                        </div>
                        <p class="email-not-found-text">
                            We couldn't find an account associated with <strong>{{ notFoundEmail }}</strong>
                        </p>
                        <p class="email-not-found-question">Would you like to create one?</p>
                        <div class="email-not-found-actions">
                            <n-button class="another_btn" @click="handleTryAnotherEmail" size="large">
                                Try another email
                            </n-button>
                            <n-button @click="handleApplyNow" secondary type="primary" size="large"
                                class="apply-now-btn">
                                Apply now
                            </n-button>
                        </div>
                    </div>
                </n-card>
            </n-modal>

            <n-modal v-model:show="showWelcomeModal" class="welcome-modal wel-full-modal" :closable="false"
                :auto-focus="false">
                <div class="welcome-modal-content">
                    <div class="modal-close-btn">
                        <n-icon size="20" class="close-icon" @click="closeWelcome">
                            <Close />
                        </n-icon>
                    </div>
                    <div class="welcome-modal-left">
                        <span class="launch">New Launch</span>
                        <h2>HopeAI Agent Hub</h2>
                        <p class="welcome-desc">Accelerate your clinical trials</p>
                        <p class="welcome-sec">with AI Clinician & AI Statistician agents</p>

                        <span class="early_access" @click="goSignIn">
                            Get Early Access

                        </span>
                    </div>
                    <div class="welcome-modal-right">
                        <template v-if="isLogIn">
                            <div class="login-box">
                                <h3>Login to Agent Hub</h3>
                                <template v-if="isSendEmailSuccess">
                                    <div class="email_code_wrap">
                                        <img style="width: 20px; color: #7a47b9; margin-bottom: 20px;"
                                            :src="imgUrl('/img/email.svg')" alt="HopeAI Agent Hub"
                                            class="welcome-logo" />
                                        <p class="email_text">
                                            <span>
                                                To continue, click the link sent to
                                            </span>
                                            <span style="font-weight: bold">{{ loginForm.email }} </span>
                                        </p>

                                        <div class="re_send">
                                            <template v-if="isReLoad">
                                                <vue-turnstile :site-key="cloud_key" v-model="token" theme="auto" />
                                            </template>
                                            Not seeing the email in your inbox?
                                            <span @click.prevent="handleLogin">Try sending again</span>
                                        </div>
                                    </div>

                                </template>
                                <template v-else>
                                    <div class="login_form">
                                        <n-input v-model:value="loginForm.email" placeholder="name@yourcompany.com"
                                            size="large" @keydown.enter.prevent />
                                        <div class="form-button-section">

                                            <div class="cloud-wrap"
                                                style="margin-bottom: 20px; display: flex; justify-content: center;"
                                                v-if="isReLoad">

                                                <vue-turnstile :site-key="cloud_key" v-model="token" theme="auto" />

                                            </div>
                                            <n-button class="welcome_login_submit" :disabled="token.length === 0"
                                                @click="Login" type="primary" size="large" secondary
                                                :loading="isSubmitLoading || token.length === 0">
                                                {{ isSubmitLoading || token.length === 0 ?
                                                    'Loading...' :
                                                    'Continue with email' }}
                                            </n-button>
                                        </div>
                                        <div class="register_entry">
                                            <span>Don't have an account?</span>
                                            <a href="javascript:;" class="register_link" @click="goSignIn">Apply
                                                now</a>
                                        </div>
                                        <div class="service_content">
                                            By continuing, you agree to the
                                            <a href="javascript:;" @click.prevent="goterms">Terms of
                                                Service</a>
                                            and acknowledge their
                                            <a href="javascript:;" @click.prevent="goprivacy">Privacy Policy</a>.
                                        </div>
                                    </div>
                                </template>

                            </div>
                        </template>
                        <template v-else>
                            <SignUp @goToLogin="handleToLogin" @close="closeWelcome" />
                        </template>
                    </div>
                </div>
            </n-modal>
        </ClientOnly>
        <MobileModal v-if="showMobileModal" @close="showMobileModal = false" />
        <header :class="['header', headerScroll ? 'active_header  animate__animated' : '']">
            <AnnouncementBar v-if="shouldShowAnnouncement" />

            <div class="container">

                <div class="nav">
                    <div class="logo" @click.prevent="go('')">
                        <img :src="imgUrl('/img/HopeAI_monochrome.svg')"
                            alt="HopeAI, Hope AI, clinical trials, AI, Copilot, adaptive design, Will Ma, Feifang Hu"
                            title="HopeAI, Hope AI, clinical trials, AI, Copilot, adaptive design, Will Ma, Feifang Hu" />
                    </div>
                    <ClientOnly>
                        <div class="right_action">
                            <div>
                                <n-dropdown class="solution_dropdown" trigger="hover" :options="options"
                                    @select="solutionSelect" size="large">
                                    Solutions
                                </n-dropdown>
                            </div>
                            <div class="menu_item" @click="go('company')">
                                Company
                            </div>
                            <div class="menu_item" @click="go('research')">
                                Research
                            </div>
                            <div class="menu_item" @click="go('news')">
                                News
                            </div>
                            <div class="menu_item" @click="go('podcast')">
                                Podcast
                            </div>
                            <div @click="openModal = true" class="signup" ref="agentHubBtn"
                                :class="{ 'breathe-focus': agentHubBreathe }">
                                Book a Demo
                            </div>


                        </div>
                        <div class="web_right_action">
                            <n-icon size="30" color="#fff" @click.prevent="openMenu = true">
                                <Menu />
                            </n-icon>
                            <transition name="menu-slide">
                                <div v-if="openMenu" class="open_modal">
                                    <div class="modal_box">
                                        <div class="menu_header">
                                            <div class="menu_logo" @click.prevent="go('')">
                                                <img :src="imgUrl('/img/HopeAI_monochrome.svg')"
                                                    alt="HopeAI, Hope AI, clinical trials, AI, Copilot, adaptive design, Will Ma, Feifang Hu"
                                                    title="HopeAI, Hope AI, clinical trials, AI, Copilot, adaptive design, Will Ma, Feifang Hu" />
                                            </div>
                                            <n-icon size="30" color="#fff" @click.prevent="openMenu = false">
                                                <Close />
                                            </n-icon>
                                        </div>
                                        <div class="menu_list">
                                            <p>
                                                <n-collapse class="list_collapse" :default-expanded-names="['2']">
                                                    <template #header-extra>
                                                    </template>
                                                    <n-collapse-item title="Solutions" name="2">
                                                         <div class="coll_item" @click.prevent="handleHopeAIWorkspace">
                                                             HopeAI Workspace
                                                         </div>
                                                        <div class="coll_item" @click.prevent="go('solutions/PUREEvidence')">
                                                            PURE
                                                            Evidence
                                                        </div>
                                                        <div class="coll_item" @click.prevent="go('solutions/synthIPD')">
                                                            SynthIPD
                                                        </div>
                                                    </n-collapse-item>
                                                </n-collapse>

                                            </p>
                                            <p @click.prevent="go('company')">
                                                Company
                                            </p>
                                            <p @click.prevent="go('research')">
                                                Research
                                            </p>
                                            <p @click.prevent="go('news')">
                                                News
                                            </p>
                                            <p @click.prevent="go('podcast')">
                                                Podcast
                                            </p>
                                            <p @click="handleMobileBookDemo" class="signup">
                                                Book a Demo
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </transition>

                            <div>
                            </div>

                        </div>
                    </ClientOnly>
                </div>
            </div>

        </header>

        <!-- HubSpot Demo Modal -->
        <div v-if="openModal" class="modal-close-overlay" @click="closeDemoModal">
            <n-icon size="20" style="color: #666;">
                <Close />
            </n-icon>
        </div>
        <n-modal v-model:show="openModal" :auto-focus="false" display-directive="show">
            <n-card style="width: 600px; max-width: 95vw; border-radius: 16px; overflow: hidden;" :bordered="false" size="huge" role="dialog" :aria-modal="true" :content-style="{ padding: 0 }">
                <!-- Desktop close button -->
                <div class="modal-close-desktop" style="position: absolute; top: 20px; right: 20px; z-index: 100;">
                    <n-icon size="24" @click.prevent="closeDemoModal" style="cursor: pointer; color: #999;">
                        <Close />
                    </n-icon>
                </div>
                <div class="request_modal" id="hubspot-form-container">
                    <transition name="fade">
                        <div v-if="formLoading" class="form-loader-overlay">
                            <n-spin size="large" />
                        </div>
                    </transition>
                    <!-- HubSpot form will be injected here with unique ID for header -->
                    <div class="hs-form-frame" id="hs-form-target-header"></div>
                </div>
            </n-card>
        </n-modal>
    </div>
</template>
<script setup lang="ts">
import { onMounted, ref, watch, nextTick, onUnmounted, computed } from 'vue';
import { useHead } from '#imports';
import { storeToRefs } from 'pinia';
import AnnouncementBar from './AnnouncementBar.vue';

const props = withDefaults(
    defineProps<{
        showAnnouncement?: boolean;
    }>(),
    {
        showAnnouncement: undefined
    }
);

// HubSpot script is now loaded globally in nuxt.config.ts
import { useAppStore } from '@/store/app';
import { useMessage } from 'naive-ui';
import VueTurnstile from 'vue-turnstile';
import SignUp from './SignUp.vue';
import MobileModal from './MobileModal.vue';
import { sendMagicLink } from "@/api/index";
import { Close, Menu } from '@vicons/ionicons5';
import { useRuntimeConfig, useRouter, useRoute } from '#imports';
import { catchApiError } from '@/utils/errorHandler';
import { onOpenBookDemoModal } from '@/utils/bookDemoModal'


const emit = defineEmits(['change']);
const message = useMessage();
// 全屏弹窗相关
const showWelcomeModal = ref(false);

const openModal = ref(false);
const formLoading = ref(false);

const checkAndCreateForm = (silent = false) => {
    const frame = document.getElementById('hs-form-target-header');
    if (!frame) {
        if (!silent) console.error('❌ HubSpot target element #hs-form-target-header not found in DOM');
        formLoading.value = false;
        return;
    }

    if (frame.children.length > 0) {
        if (!silent) console.log('ℹ️ HubSpot form already exists in DOM');
        nextTick(() => {
            formLoading.value = false;
        });
        return;
    }

    const hbspt = (window as any).hbspt;
    if (hbspt && hbspt.forms) {
        if (!silent) console.log('✅ hbspt.forms found, calling create...');
        try {
            let formRenderTimeout: any = null;
            hbspt.forms.create({
                region: "na1",
                portalId: "23805798",
                formId: "2401e535-2cd1-4e4e-8a8c-98ace6a41db0",
                target: "#hs-form-target-header",
                onFormReady: () => {
                    if (!silent) console.log('🎉 HubSpot form ready in headItem!');
                    if (formRenderTimeout) clearTimeout(formRenderTimeout);
                    // Minimal delay to ensure iframe is painted
                    setTimeout(() => {
                        formLoading.value = false;
                    }, 100);
                },
                onFormSubmit: () => {
                    console.log('📩 HubSpot form submitted!');
                }
            });

            // Fallback timeout: if HubSpot doesn't fire onFormReady within 2s, hide spinner
            formRenderTimeout = setTimeout(() => {
                if (formLoading.value) {
                    if (!silent) console.warn('⚠️ HubSpot form ready callback timed out in headItem');
                    formLoading.value = false;
                }
            }, 2000);
        } catch (err) {
            console.error('❌ Error creating HubSpot form:', err);
            formLoading.value = false;
        }
    } else {
        if (!silent) console.error('❌ hbspt or hbspt.forms missing');
        formLoading.value = false;
    }
};

watch(openModal, (val) => {
    if (val) {
        formLoading.value = true;
        console.log('🔄 HubSpot modal opened in headItem, starting form creation...');

        nextTick(() => {
            const isHbsptReady = () => (window as any).hbspt && (window as any).hbspt.forms;

            if (isHbsptReady()) {
                checkAndCreateForm();
            } else {
                console.log('⏳ Waiting for HubSpot script to load...');
                const checkHbspt = setInterval(() => {
                    if (isHbsptReady()) {
                        clearInterval(checkHbspt);
                        console.log('✅ HubSpot script loaded dynamically!');
                        checkAndCreateForm();
                    }
                }, 200);

                setTimeout(() => {
                    if (checkHbspt) clearInterval(checkHbspt);
                    if (formLoading.value) {
                        console.warn('⚠️ HubSpot load timed out after 10s');
                        formLoading.value = false;
                    }
                }, 10000);
            }
        });
    }
});

const closeDemoModal = () => {
    openModal.value = false;
}

const loginForm = ref({ email: '' });
const isReLoad = ref(true);
const config = useRuntimeConfig();

// 使用 Pinia store 控制首次进入
// const appStore = useAppStore();
// const { firstEnter } = storeToRefs(appStore);

const isSendEmailSuccess = ref(false);
const isSubmitLoading = ref(false);
const isLogIn = ref(true);
const showEmailNotFoundModal = ref(false);
const notFoundEmail = ref('');
// const base_url = config.public.baseHopeAI;
// const redirect = config.public.redirect;

// Agent Hub 聚焦呼吸动画
const agentHubBtn = ref<HTMLElement | null>(null);
const agentHubBreathe = ref(false);
let hasBreathed = false;

watch(() => showWelcomeModal.value, (val) => {
    if (!val && !hasBreathed) {
        nextTick(() => {
            agentHubBreathe.value = true;
            agentHubBtn.value?.focus?.();
            hasBreathed = true;
            setTimeout(() => {
                agentHubBreathe.value = false;
            }, 1600);
        });
    }
});

const Login = async () => {
    if (loginForm.value.email.length === 0) {
        message.error('Please enter your email');
        return;
    }
    // 邮箱是否有效
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(loginForm.value.email)) {
        message.error('Please enter a valid email address');
        return;
    }

    const sendData: any = {
        email: loginForm.value.email,
        product_code: 'agent-hub',
        base_url: "https://login.hopeai.co/#/loading",
        redirect: "https://hub.hopeai.co",
    }
    isSubmitLoading.value = true;
    try {
        let emailRes: any = await sendMagicLink(sendData);
        if (emailRes) {
            isSubmitLoading.value = false;
            isSendEmailSuccess.value = true;
            isReLoad.value = false;
            token.value = '';
            setTimeout(() => {
                // HubSpot script is now loaded globally in nuxt.config.ts
                // If the specific embed script is needed for this page, it's already covered by the global v2.js
                // but we can leave a placeholder if needed.
                isReLoad.value = true;
            }, 5)
        }
    } catch (e: any) {
        console.log('error', e);//E4305
        const errorResult = catchApiError(e);

        // 如果是邮箱不存在的错误(E4305)，显示特殊弹窗
        if (errorResult.error_code === 'E4305') {
            notFoundEmail.value = loginForm.value.email;
            showEmailNotFoundModal.value = true;
        } else {
            // 其他错误显示普通提示
            message.error(errorResult.message);
        }

        isSubmitLoading.value = false;
        isReLoad.value = false;
        token.value = '';
        setTimeout(() => {
            isReLoad.value = true;
        }, 5)
    }

};

const handleLogin = () => {
    if (token.value.length === 0) {
        message.error('Please complete verification first');
        return;
    }
    Login();
}

// 处理邮箱未找到弹窗的操作
const handleTryAnotherEmail = () => {
    showEmailNotFoundModal.value = false;
    loginForm.value.email = '';
}

const handleApplyNow = () => {
    showEmailNotFoundModal.value = false;
    goSignIn();
}





const showMobileModal = ref(false);
let opensTimer: ReturnType<typeof setTimeout> | null = null;
const opens = () => {
    if (showWelcomeModal.value) return;

    // Reset states
    isLogIn.value = true;
    isSendEmailSuccess.value = false;
    loginForm.value.email = '';
    token.value = '';
    isReLoad.value = true;
    isSubmitLoading.value = false;
    hasBreathed = false;

    // Debounce to avoid rapid triggers
    if (opensTimer) clearTimeout(opensTimer);
    opensTimer = setTimeout(() => {
        if (isMobile.value) {
            showMobileModal.value = true;
        } else {
            showWelcomeModal.value = true;
        }
    }, 80);
}

const openMenu = ref(false);


const router = useRouter();
const route = useRoute();

const isHomePage = computed(() => {
    return route.path === '/' || route.path === '';
});

const shouldShowAnnouncement = computed(() => {
    if (props.showAnnouncement !== undefined) {
        return props.showAnnouncement;
    }
    return isHomePage.value;
});

const cloud_key = config.public.cloudKey || "";
const token = ref<string>('');

// console.log(cloud_key);

const imgUrl = (url: string) => {
    return config.app.cdnURL + url;
}
const headerScroll = ref(false);
const options = ref([
    {
        label: 'HopeAI Workspace',
        key: 'HopeAIWorkspace'
    },
    {
        label: 'PURE Evidence',
        key: 'solutions/PUREEvidence'
    },
    {
        label: 'SynthIPD',
        key: 'solutions/synthIPD'
    },
]);

const goSignIn = () => {
    isLogIn.value = false;
    isReLoad.value = false;
    token.value = '';
    setTimeout(() => {
        isReLoad.value = true;
    }, 5)
}
const solutionSelect = (option: string) => {
    if (option === 'HopeAIWorkspace') {
        window.open('https://workspace.hopeai.co/', '_blank');
        return;
    }
    router.push({ path: `/${option}` });
    const hopeaiHome = document.getElementsByClassName('hopeai_home')[0];
    // 回到顶部
    if (hopeaiHome) {
        hopeaiHome.scrollTop = 0;
    }
}

const handleHopeAIWorkspace = () => {
    openMenu.value = false;
    window.open('https://workspace.hopeai.co/', '_blank');
}

const handleMobileBookDemo = () => {
    openMenu.value = false;
    openModal.value = true;
}

const handleToLogin = () => {
    isLogIn.value = true;
    loginForm.value.email = '';
    isSendEmailSuccess.value = false;
    isReLoad.value = false;
    token.value = '';
    setTimeout(() => {
        isReLoad.value = true;
    }, 5)
}

const go = (name: string) => {
    router.push({ path: `/${name}` });
    const hopeaiHome = document.getElementsByClassName('hopeai_home')[0];
    // 回到顶部
    if (hopeaiHome) {
        hopeaiHome.scrollTop = 0;
    }
    if (route.name === 'index' || route.name === name) {
        openMenu.value = false;
    }
}



const goprivacy = () => {
    nextTick(() => {
        window.open('https://login.hopeai.co/#/privacy_policy', '_blank');
    })
}

const goterms = () => {
    nextTick(() => {
        window.open('https://login.hopeai.co/#/terms_of_service', '_blank');
    })
}




watch(() => token.value, (val) => {
    if (val && val.length > 0) {
        localStorage.setItem('CToken', val)
    }
}, { immediate: true })

watch(() => openMenu.value, (val) => {
    if (val) {
        emit('change', true);
        document.body.classList.add('no-scroll');
    } else {
        emit('change', false);
        document.body.classList.remove('no-scroll');
    }
})

const closeWelcome = () => {
    showWelcomeModal.value = false;
    // 重置相关状态
    isLogIn.value = true;
    isSendEmailSuccess.value = false;
    loginForm.value.email = '';
    token.value = '';
    isReLoad.value = true;
    isSubmitLoading.value = false;
    // appStore.setFirstEnter(false);
}


const isMobile = ref(false);
let resizeTimer: ReturnType<typeof setTimeout> | null = null;

const checkIsMobile = () => {
    // 检查屏幕尺寸小于768px都归类为移动端
    const newIsMobile = window.innerWidth <= 768;
    if (newIsMobile !== isMobile.value) {
        isMobile.value = newIsMobile;
    }
};

const debouncedCheckIsMobile = () => {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        checkIsMobile();
    }, 200);
};


const handleElementScroll = () => {
    const el = document.getElementsByClassName('home_wrap')[0];
    if (el) {
        headerScroll.value = el.scrollTop > 0;
    }
};

const handleWindowScroll = () => {
    headerScroll.value = window.scrollY > 0;
};

const handleGlobalAppScroll = () => {
    const el = document.getElementsByClassName('hopeai_home')[0];
    if (el) {
        headerScroll.value = el.scrollTop > 0;
    }
}

onMounted(() => {
    // 只在首页首次进入时弹窗
    checkIsMobile();
    window.addEventListener('resize', debouncedCheckIsMobile);

    isReLoad.value = false;
    token.value = '';
    setTimeout(() => {
        isReLoad.value = true;
        console.log('🔄 SignUp vue-turnstile force reloaded on mount');
    }, 5);

    // hopeai_home 监听滚动 
    const homeWrap = document.getElementsByClassName('home_wrap')[0];
    const globalApp = document.getElementsByClassName('hopeai_home')[0];

    console.log('homeWrap', homeWrap);

    if (homeWrap) {
        homeWrap.addEventListener('scroll', handleElementScroll);
    } else if (globalApp) {
        globalApp.addEventListener('scroll', handleGlobalAppScroll);
    } else {
        window.addEventListener('scroll', handleWindowScroll);
    }

    // Pre-load HubSpot form in background
    nextTick(() => {
        const isHbsptReady = () => (window as any).hbspt && (window as any).hbspt.forms;
        if (isHbsptReady()) {
            checkAndCreateForm(true);
        } else {
            const checkHbspt = setInterval(() => {
                if (isHbsptReady()) {
                    clearInterval(checkHbspt);
                    checkAndCreateForm(true);
                }
            }, 1000);
            setTimeout(() => clearInterval(checkHbspt), 20000);
        }
    });
})

onUnmounted(() => {
    window.removeEventListener('resize', debouncedCheckIsMobile);
    window.removeEventListener('scroll', handleWindowScroll);

    const homeWrap = document.getElementsByClassName('home_wrap')[0];
    if (homeWrap) {
        homeWrap.removeEventListener('scroll', handleElementScroll);
    }

    const globalApp = document.getElementsByClassName('hopeai_home')[0];
    if (globalApp) {
        globalApp.removeEventListener('scroll', handleGlobalAppScroll);
    }

    if (resizeTimer) clearTimeout(resizeTimer);
});

const removeBookDemoModalListener = onOpenBookDemoModal(() => {
    openMenu.value = false;
    openModal.value = true;
});

onUnmounted(() => {
    removeBookDemoModalListener();
})

</script>
<style lang="scss">


.no-scroll {
    height: 100vh;
    overflow: hidden;
}

@keyframes slideDown {
    from {
        transform: translateY(-100%);
    }

    to {
        transform: translateY(0);
    }
}

.open_modal {
    position: fixed;
    inset: 0% 0% auto;
    height: 100svh;
    width: 100vw;
    left: 0;
    background: #000;
    z-index: 1000;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    will-change: transform;
}

.menu-slide-enter-active,
.menu-slide-leave-active {
    transition: opacity 0.15s ease-out;
}

.menu-slide-enter-from,
.menu-slide-leave-to {
    opacity: 0;
}

.modal_box {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.home_wrap {
    width: 100%;
    height: 100vh;
    /* height: 100%; */
    overflow-y: auto;
    overflow-x: hidden;
    // cursor: pointer;

    &.mobileModal {
        height: 100vh;
        overflow: hidden;
        // background: #0D121F;
    }
}


.active_header {
    -webkit-backdrop-filter: blur(24px) saturate(1.6);
    backdrop-filter: blur(24px) saturate(1.6);
    background: rgba(8, 7, 15, 0.6);
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.06), 0 4px 24px rgba(0, 0, 0, 0.3);
}




.menu_modal {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: #0D121F;
    height: 100vh;
    overflow: hidden;

    .menu_content {
        position: relative;
        padding: 0 20px;
        height: 100vh;
        overflow: hidden;
        background: #0D121F;
        -webkit-overflow-scrolling: touch;




    }
}



.demo_div {
    min-height: 405px;
    background: #f5f6f9;
    width: 100%;
    border-radius: 8px;
}

.demo_divs {
    min-height: 405px;
    background: #f5f6f9;
    width: 100%;
    border-radius: 8px;
}

.logo {
    width: 140px;
    display: flex;
    align-items: center;
    // cursor: pointer;

    img {
        position: relative;
        z-index: 100;
        cursor: pointer;
        width: 100%;
        // cursor: pointer;
        pointer-events: auto;
    }
}

.solution_dropdown .n-dropdown-option .n-dropdown-option-body .n-dropdown-option-body__label {
    font-weight: 600;
}

.solution_dropdown .n-dropdown-option .n-dropdown-option-body {
    height: 56px;
    line-height: 56px;
}


.email_code_wrap {
    align-items: center;
    // background-color: var(--vt-c-white);
    // filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.05));
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 40px;
    position: relative;
    width: 440px;

    img {
        display: block;
    }

    p {
        text-align: center;
    }

    .email_wrap {
        display: flex;
        flex-direction: column;
        gap: 14px;
        width: 100%;

        button {
            span {
                font-weight: bold;
            }
        }
    }

    .re_send {
        text-align: center;
        font-size: 12px;
        margin-top: 20px;

        span {
            display: inline-block;
            text-decoration: underline;
            cursor: pointer;
            user-select: none;
        }
    }
}

.right_action {
    display: flex;
    align-items: center;
    gap: 40px;
    color: #fff;
    pointer-events: auto;

    div {
        font-size: 18px;
        font-weight: 600;
        height: 48px;
        line-height: 48px;
        // cursor: pointer;
        pointer-events: auto;
        position: relative;
        z-index: 100;
        cursor: pointer;

        span {
            font-size: 18px;
            font-weight: 600;
            // cursor: pointer;
        }

        &::after {
            content: "";
            position: absolute;

        }


        &.menu_item {
            &:hover {
                &::after {
                    content: "";
                    position: absolute;
                    left: 12px;
                    right: 12px;
                    height: 4px;
                    /* width: 100%; */
                    background: #7A47B9FF;
                    bottom: 0;
                    border-radius: 8px;

                }
            }
        }

    }

    .btn {
        user-select: none;
        border: 0;
        line-height: 48px;
        font-size: 16px;
        // cursor: pointer;
        text-align: center;
    }

    .btn.login {
        background: none;
        color: #fff;
        /* padding: 0 24px; */
        border-radius: 24px;
        flex: none;
        order: 1;
        flex-grow: 0;
        width: 95px;
        letter-spacing: 0.5px;

    }

    .signup {
        letter-spacing: 0.5px;
        flex: none;
        order: 1;
        flex-grow: 0;
        padding: 0 24px;
        font-weight: 600;
        font-size: 16px;
        border-radius: 99px;
        border: 0;
        background: linear-gradient(135deg, #6836a8 0%, #be35b0 100%);
        color: #fff;
        height: 48px;
        line-height: 48px;
        cursor: pointer;
        transition: opacity 0.3s;

        &:hover {
            opacity: 0.9;
            transform: none;
        }
    }
}

.web_right_action {
    display: none;
}

.header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1001;
    // cursor: pointer !important;

    .container {
        height: 90px;
        // cursor: pointer;
    }
}

.nav {
    height: 90px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background 0.3s ease;
    // cursor: pointer;
}

.solution_dropdown {
    margin-top: 14px !important;
}

.register_entry {
    text-align: center;
    margin: 16px 0;
    font-size: 14px;
    color: #666;

    .register_link {
        color: #7a47b9;
        text-decoration: none;
        font-weight: 500;
        margin-left: 4px;

        &:hover {
            text-decoration: underline;
        }
    }
}

.service_content {
    font-size: 14px;
    text-align: center;
    margin-bottom: 20px;
    margin: 24px 0 0 0;
    color: #666;
    font-size: 12px;

    a {

        color: #666;
        text-decoration: underline;
    }
}

.container {
    max-width: 1240px;
    height: 100%;
    margin: 0 auto;
}

.modal-close-btn {
    position: absolute;
    top: -12px;
    right: -16px;
    cursor: pointer;
}

.form-button-section {
    width: 100%;
}

.request_modal {
    margin: 0 auto;

    .request_notice {
        color: var(--mastergo-com-black-50, rgba(0, 0, 0, 0.50));
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 32px;
        margin-top: -24px;
    }

    .n-form-item-label__text {
        color: #23202A;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
    }

    .form-field {
        width: 100%;
    }

    .field-label {
        display: block;
        color: #23202A;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 12px;
    }



    .form-button-section {
        margin-top: 12px;
    }

    .n-form-item {
        margin-bottom: 4px;
    }

    .n-form-item__feedback-wrapper {
        margin-top: 4px;
    }

    .n-form-item-label__text {
        font-weight: 500;
        color: #364153;
    }
}

.account_card {
    .n-card__content {
        padding-top: 0;
    }


}



.welcome_login_submit {
    width: 100%;
    color: #FFF !important;
    font-size: 16px;
    font-weight: 600 !important;
    height: 40px;
    line-height: 40px;
    letter-spacing: 0.5px;
    border-radius: 999px;
    background: linear-gradient(98deg, rgba(190, 53, 176, 0.90) -6.37%, rgba(122, 71, 185, 0.90) 87.51%);
    box-shadow: 1px 3px 4px 0 rgba(0, 0, 0, 0.25);

    .n-button__content {
        font-weight: 600 !important;
    }
}

.login_submit {
    color: #FFF !important;

}

.request_form_item {
    width: 100%;
    display: flex;
    flex-direction: column;

    p {
        color: var(--portal-unlearn-ai-baltic-sea, #23202A);
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
    }

    .n-input {
        margin-top: 10px;
    }
}

.header_mobile_modal {
    margin: 0;
    width: 100vh !important;
    height: 100vh !important;
    border-radius: 0;
    background: #0D121F !important;

    .n-card-header {
        width: 100%;
        padding: 0;
        display: block;
    }


}

.menu_header {
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding: 0 20px;
    background: #000;
    position: relative;
    z-index: 1001;

    .menu_logo {
        width: 140px;
        display: flex;
        align-items: center;

        img {
            width: 100%;
        }
    }
}

.menu_list {
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    margin-top: 20px;
    padding: 0 20px;

    p {
        font-size: 32px;
        font-weight: 500;
        line-height: 48px;
        opacity: 0;
        animation: fadeInUp 0.4s ease-out forwards;

        &:nth-child(1) { animation-delay: 0.1s; }
        &:nth-child(2) { animation-delay: 0.15s; }
        &:nth-child(3) { animation-delay: 0.2s; }
        &:nth-child(4) { animation-delay: 0.25s; }
        &:nth-child(5) { animation-delay: 0.3s; }
        &:nth-child(6) { animation-delay: 0.35s; }
    }

    .signup {
        border-radius: 99px;
        letter-spacing: 0.5px;
        flex: none;
        order: 1;
        flex-grow: 0;
        padding: 0 30px;
        line-height: 48px;
        margin-top: 12px;
        font-size: 16px;
        border-radius: 99px;
        border: 1px solid #6836A8;
        background: linear-gradient(135deg, #6836a8 0%, #be35b0 100%);

        &:hover {
            background: #7A47B9FF;
        }
    }

    .coll_item {
        font-size: 22px;
        font-weight: 500;
        line-height: 48px;
        color: #bbb;
        padding-left: 20px;

        &:last-child {
            padding-bottom: 20px;
        }
    }
}

.list_collapse {
    .n-collapse-item__header-main {
        color: #fff !important;
        font-size: 32px;
        font-weight: 500 !important;
        line-height: 48px;
    }

    .n-collapse-item-arrow {
        display: none !important;
    }
}



@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translate3d(0, -15px, 0);
        --webkit-transform: translate3d(0, -15px, 0);
    }

    to {
        opacity: 1;
        transform: none;
        --webkit-transform: none;
    }
}

@keyframes bounceIn {
    0% {
        opacity: 0;
        transform: scale(0.3);
    }

    50% {
        opacity: 1;
        transform: scale(1.05);
    }

    70% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes pulse {
    0% {
        opacity: 0.6;
        transform: translate(-50%, -50%) scale(1);
    }

    50% {
        opacity: 0.3;
        transform: translate(-50%, -50%) scale(1.1);
    }

    100% {
        opacity: 0.6;
        transform: translate(-50%, -50%) scale(1);
    }
}

@keyframes checkmark {
    to {
        stroke-dashoffset: 0;
    }
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateX(30px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.fadeInDown {
    animation-name: fadeInDown;
    --webkit-animation-name: fadeInDown;
    animation-duration: 1.5s;
}

.welcome-modal {
    z-index: 2000 !important;

    .n-modal-body-wrapper {
        width: 100vw !important;
        height: 100vh !important;
        max-width: 100vw !important;
        max-height: 100vh !important;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(13, 18, 31, 0.98);
    }

    .n-modal-body {
        padding: 0 !important;
        width: 100vw;
        height: 100vh;
        background: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.welcome-modal-content {
    display: flex;
    width: 100vh;
    max-width: 96vw;
    min-height: 480px;
    border-radius: 20px;
    overflow: hidden;
    background: url(/img/welcome_bg.png) no-repeat center;
    background-size: cover;
}

.welcome-modal-left {
    flex: 1;
    color: #fff;
    padding: 48px 36px 48px 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(3px);

    .launch {

        background: linear-gradient(93deg, #FB59EB 2.19%, #9A58ED 97.81%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        color: #FFF;
        text-align: center;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;

    }

    h2 {
        color: #FFF;
        font-size: 64px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
        margin-top: 30px;
        text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.25);
    }

    p.welcome-desc {
        color: #FFF;
        font-size: 36px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.25);
        margin-top: 32px;

    }

    p.welcome-sec {
        color: #FFF;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.25);
    }

    .early_access {
        display: inline-block;
        color: #FFF;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
        border-radius: 60px;
        opacity: 0.9;
        background: var(--Linear, linear-gradient(98deg, #BE35B0 -6.37%, #7A47B9 87.51%));
        box-shadow: 0.903px 2.71px 3.614px 0 rgba(0, 0, 0, 0.25);
        cursor: pointer;
        margin-top: 24px;
        padding: 12px 24px;
    }
}

.welcome-logo {
    width: 120px;
    margin-bottom: 32px;
}


.welcome-features {
    margin: 0;
    padding: 0 0 0 18px;
    font-size: 15px;
    line-height: 2;
}

.welcome-modal-right {


    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 48px 36px;
    width: 540px;
    height: 100%;
    position: relative;
    background: rgba(255, 255, 255, 60%);
    backdrop-filter: blur(56px);

    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
        pointer-events: none;
        background: rgba(255, 255, 255, 80%);
        backdrop-filter: blur(56px);
    }

    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
        pointer-events: none;
        background: rgba(255, 255, 255, 1);
        mix-blend-mode: overlay;
    }
}

.login-box {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background: #fff;
    padding: 32px 24px 24px 24px;
    display: flex;
    gap: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}



.login-box h3 {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 36px;
    color: #1a1a1a;
    width: 100%;
    text-align: center;
}

.login-tip {
    margin-top: 18px;
    font-size: 15px;
    color: #666;
    text-align: center;
}

.login-tip a {
    color: #7A47B9;
    text-decoration: underline;
    margin-left: 6px;
    font-weight: 600;
    cursor: pointer;
}

.login-error {
    color: #e74c3c;
    margin-top: 12px;
    font-size: 14px;
    text-align: center;
}


// ...existing code...

.wel-full-modal {
    z-index: 3000 !important;
    position: fixed !important;
    inset: 0 !important;
    width: calc(100vw - 160px) !important;
    height: calc(100vh - 200px) !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;

    border-radius: 24px !important;
    box-shadow: none !important;

}

.wel-full-modal .n-modal-body-wrapper,
.wel-full-modal .n-modal-body {
    width: 100vw !important;
    height: 100vh !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    border-radius: 0 !important;
    background: transparent !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-shadow: none !important;
    padding: 0 !important;
}


.wel-full-modal .welcome-modal-content {
    width: calc(100vw - 200px);
    max-width: 900px;
    min-height: 480px;
    // background: #fff;
    border-radius: 20px;
    // box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    overflow: hidden;
    display: flex;
    margin-left: 100px;
    margin-right: 100px;
    position: relative;

}

.wel-full-modal .modal-close-btn {
    position: absolute;
    top: 24px;
    right: 24px;
    z-index: 10;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s;
}

.wel-full-modal .modal-close-btn:hover {
    background: #f5f5f5;
}

.wel-full-modal .close-icon {
    color: #7A47B9;
    font-size: 22px;
    background: #fff;
}


@media (max-width: 576px) {

    .container {
        margin: 0 20px;
    }

    .demo_div {
        width: 100%;
    }

    .right_action {
        display: none;
    }

    .web_right_action {
        display: block;
    }

    .request_modal {
        height: calc(100vh - 120px);
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;

        .request_notice {
            margin-top: 0;
        }
    }

    /* 修复移动端 home_wrap 滚动问题 */
    .home_wrap {
        height: 100vh;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
    }

    .apply-modal {
        .n-modal-mask {
            background: rgba(0, 0, 0, 0.9);
        }

        .n-modal-body-wrapper {
            width: 100vw !important;
            height: 100vh !important;
            max-width: 100% !important;
        }

        .account_card {
            width: 100vw !important;
            height: 100vh !important;
            max-height: 100vh !important;
            border-radius: 0 !important;
            margin: 0 !important;

            .n-card__content {
                padding: 20px;
                height: 100vh;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
            }

            .custom-modal-header {
                position: sticky;
                top: 0;
                background: white;
                z-index: 10;
                padding: 20px 0;
                margin-top: 0;
            }

            .success-content {
                padding: 20px;
                height: calc(100vh - 40px);
                display: flex;
                flex-direction: column;
                justify-content: center;
            }
        }
    }

    .mobile_modal {
        margin: 0;
        width: 100vh !important;
        height: 100vh !important;
        border-radius: 0;
    }

    .wel-full-modal .welcome-modal-content {
        width: 100vw;
        min-width: 0;
        border-radius: 0;
        box-shadow: none;
        margin: 0;
    }

    .wel-full-modal .welcome-modal-left,
    .wel-full-modal .welcome-modal-right {
        padding: 20px 6px;
    }

    .wel-full-modal .modal-close-btn {
        top: 8px;
        right: 8px;
        width: 32px;
        height: 32px;
    }

    .welcome-modal-left {
        display: none;
    }

    .wel-full-modal {
        width: 100vw !important;
        height: 100vh !important;
        inset: 0 !important;
        border-radius: 0 !important;
        min-height: none !important;
    }

    .login-box h3 {
        font-size: 28px;
    }

    .lunch {


        .lunch_box {
            gap: 10px;

            p {
                font-size: 14px;
                font-weight: 500;

                &.btns {
                    padding: 6px 16px;
                    white-space: nowrap;
                }
            }
        }


    }


}

@media (min-width: 391px) and (max-width: 577px) {
    .welcome-modal-left {
        display: none;
    }
}

@media (min-width: 577px) and (max-width: 768px) {
    .container {
        margin: 0 40px;
    }

    .right_action {
        display: none;
    }

    .web_right_action {
        display: block;
    }

    .menu_modal .menu_content .menu_header .menu_logo {
        width: 140px;
    }

    .apply-modal {
        .n-modal-body-wrapper {
            width: 100vw !important;
            height: 100vh !important;
            max-width: 100% !important;
        }

        .account_card {
            width: 100vw !important;
            height: 100vh !important;
            max-height: 100vh !important;
            border-radius: 0 !important;
            margin: 0 !important;

            .n-card__content {
                padding: 30px;
                height: 100vh;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
            }
        }
    }

    .welcome-modal-left {
        display: none;
    }

    .welcome-modal-right {
        width: 100%;
    }
}

@media (min-width: 769px) and (max-width: 1365px) {
    .container {
        margin: 0 80px;
    }



    .welcome-modal-right {
        width: 460px;
    }

    .welcome-modal-left .launch {
        font-size: 28px;
    }

    .welcome-modal-left h2 {
        font-size: 32px;
    }

    .welcome-modal-left p.welcome-desc {
        font-size: 28px;
    }

    .welcome-modal-left p.welcome-sec {
        font-size: 20px;
    }

    .welcome-modal-left p.early_access {
        font-size: 20px;
    }

    .wel-full-modal .modal-close-btn {
        top: 12px;
        right: 12px;
        width: 36px;
        height: 36px;
    }

    .lunch {


        .lunch_box {
            gap: 20px;

            p {

                font-size: 14px;
                font-weight: 500;

                &.btns {
                    padding: 6px 16px;
                }
            }
        }


    }


}


.breathe-focus {
    animation: breathe-focus 1.2s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 2002 !important;
}

@keyframes breathe-focus {
    0% {
        transform: scale(1);
        background: #6939A3;
        color: #fff;
        box-shadow: 0 0 0 0 rgba(122, 71, 185, 0.3);
    }

    50% {
        transform: scale(1.05);
        background: linear-gradient(98deg, #8A4FB3 0%, #7A47B9 100%);
        color: #fff;
        // box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.9);
    }

    100% {
        transform: scale(1);
        background: #6939A3;
        color: #fff;
        box-shadow: 0 0 0 0 rgba(122, 71, 185, 0.3);
    }
}

// Email Not Found Modal 样式
.email-not-found-modal {
    width: 560px;
    max-width: 560px;

    .n-card {
        width: 560px;
        max-width: 560px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    }
}

.email-not-found-content {
    padding: 8px;

    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;

        h3 {
            font-size: 24px;
            font-weight: 600;
            color: #1a1a1a;
            margin: 0;
        }

        .not-fund-modal-close-btn {

            background: rgba(255, 255, 255, 0.85);
            border-radius: 50%;

            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: background 0.2s;
        }

        .close-icon {
            color: #0D121F;
            font-size: 22px;
            background: #fff;

            &:hover {
                color: #333;
            }
        }
    }

    .email-not-found-text {
        font-size: 16px;
        line-height: 1.6;
        color: #333;
        margin-bottom: 4px;
        text-align: center;

        strong {
            color: #7A47B9;
            font-weight: 600;
        }
    }

    .email-not-found-question {
        font-size: 16px;
        color: #666;
        text-align: center;
        margin-bottom: 32px;
    }

    .email-not-found-actions {
        display: flex;
        gap: 20px;
        justify-content: space-between;
        margin-bottom: 16px;

        button {
            flex: 1;

        }

        .another_btn {
            border-radius: 99px;

            span {
                font-weight: bold;
            }
        }

        .apply-now-btn {
            width: 100%;
            color: #FFF !important;
            font-size: 16px;
            font-weight: 600 !important;
            height: 40px;
            line-height: 40px;
            letter-spacing: 0.5px;
            border-radius: 99px;
            background: linear-gradient(98deg, rgba(190, 53, 176, 0.9) -6.37%, rgba(122, 71, 185, 0.9) 87.51%);
            // box-shadow: 1px 3px 4px 0 rgba(0, 0, 0, 0.25);

            span {
                font-weight: bold;
            }

            &:hover {
                opacity: 0.9;
            }
        }
    }
}

@media (max-width: 768px) {
    .email-not-found-modal {
        width: calc(100vw - 40px) !important;
        max-width: calc(100vw - 40px) !important;

        .n-card {
            width: calc(100vw - 40px) !important;
            max-width: calc(100vw - 40px) !important;
        }
    }

    .email-not-found-content {
        padding: 12px;

        .modal-header {
            margin-bottom: 20px;

            h3 {
                font-size: 20px;
            }

            .not-fund-modal-close-btn {
                width: 32px;
                height: 32px;
            }

            .close-icon {
                font-size: 18px;
            }
        }

        .email-not-found-text {
            font-size: 14px;
            margin-bottom: 8px;
        }

        .email-not-found-question {
            font-size: 14px;
            margin-bottom: 24px;
        }

        .email-not-found-actions {
            flex-direction: column-reverse;
            gap: 12px;
            margin-bottom: 0;

            button {
                max-width: 100%;
                width: 100%;
            }

            .another_btn,
            .apply-now-btn {
                height: 44px;
                line-height: 44px;
                font-size: 16px;
            }
        }
    }
}

/* HubSpot Form Modal Styles */
.modal-close-overlay {
  display: none; /* hidden on desktop, desktop uses in-card button */
  position: fixed;
  top: 20px;
  right: 2.5vw;
  z-index: 3000;
  cursor: pointer;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  transition: background 0.2s;
}
.modal-close-overlay:hover { background: #f0f0f0; }
@media (max-width: 768px) {
  .modal-close-overlay { display: flex; }
  .modal-close-desktop { display: none; }
}

.request_modal {
  position: relative;
  width: 100%;
  min-height: 400px;
  background: #fff;
}

@media (min-width: 769px) {
  .request_modal {
    min-height: 794px;
  }
}

.form-loader-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  z-index: 10;
}

.hs-form-frame {
  width: 100%;
  min-height: 400px;
}

@media (max-width: 768px) {
  .hs-form-frame {
    min-height: 600px;
  }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
